/**
 * Modal
 *
 */
import React from 'react'
import { Modal, message, Tabs } from 'antd'
import Exception from '../../../Exception'
import { saveEstimacionFormValues, EstimacionForm } from './Form'
import { EstimacionPartidas } from './Partidas'
import { Panel } from '../../../components'
import { EstimacionOtrosCargosTable } from './OtrosCargos'
import { SubSolicitudPagoAdjuntos } from '../Components/SolicitudPagoAdjuntos'
const { TabPane } = Tabs

/**
 *
 * @param {{ estimacionId?: number, subcontratoId: number, onSave?(): void, onCancel?(): void, onRemoved?(): void }} props
 * @returns
 */
export function EstimacionFormModal(props) {
  const [tab, setTab] = React.useState('1')

  /**
   *
   */
  const onSave = (frm) => {
    if ((!frm) || (Object.keys(frm).length <= 1)) {
      message.warn('No se han especificado datos')
      return
    }

    saveEstimacionFormValues(props.estimacionId, { ...frm, iId: undefined })
      .then(record => {
        props.onSave && props.onSave({
          id: record.iId,
          status: record.sStatus,
          subContratoId: record.iIdSubContrato,
        })
      })
      .catch((err) => {
        Exception.load(err).show()
      })
  }

  const estimacionForm = (
    <EstimacionForm
      id={props.estimacionId}
      onRemoved={props.onRemoved}
      onSave={data => onSave(data)}
    />
  )

  const widths = {
    gral: 700,
    partidas: '90%',
    otros_cargos: 700,
    adjuntos: '70%',
  }

  return (
    <Modal
      title={props.estimacionId ? 'EDITAR ESTIMACIÓN' : 'NUEVA ESTIMACIÓN'}
      style={{ top: 20 }}
      visible={props.estimacionId !== null && props.estimacionId !== undefined}
      width={widths[tab] || 700}
      onOk={props.onCancel}
      onCancel={() => {
        setTab('1')
        props.onCancel && props.onCancel()
      }}
      footer={false}>

      <div style={{ flex: 1, position: 'relative'}}>
        {props.estimacionId ? (
          <Tabs defaultActiveKey='gral' onChange={setTab}>
            {/* inf. gral (form) */}
            <TabPane tab='INF. GENERAL' key='1' style={{ overflow: 'auto', display: 'flex', flexDirection: 'column'}}>
              {/* estimaciones */}
              <Panel>
                {estimacionForm}
              </Panel>
            </TabPane>

            {/* partidas */}
            <TabPane tab='PARTIDAS' key='partidas'>
              <div style={{ display: 'flex', position: 'relative' }}>
                <div style={{ overflow: 'auto', flex: 1 }}>
                  <EstimacionPartidas
                    subContratoId={props.subcontratoId}
                    estimacionId={props.estimacionId}
                  />
                </div>
              </div>
            </TabPane>

            {/* otros cargos */}
            <TabPane tab='OTROS CARGOS' key='otros_cargos'>
              <EstimacionOtrosCargosTable
                estimacionId={props.estimacionId}
              />
            </TabPane>

            {/* adjuntos */}
            <TabPane tab='ADJUNTOS' key='adjuntos'>
              <SubSolicitudPagoAdjuntos
                  registroId={props.estimacionId}
                  requerido={{
                    campo: 'iIdEstimacion',
                    modelo: 'SubEstimacion',
                    registro: props.estimacionId,
                    referencia: null,
                  }}
                />
            </TabPane>
          </Tabs>
        ) : (estimacionForm)}
      </div>
    </Modal>
  )
}
